import React from 'react';

const CHAINS = ['Global', 'Lidl GB', 'Lidl DE', 'Morrisons', 'Asda'] as const;
export type Chain = (typeof CHAINS)[number];

const STORAGE_KEY = 'forge_dashboard_chain';

export function loadChain(): Chain {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored && (CHAINS as readonly string[]).includes(stored)) return stored as Chain;
  return 'Global';
}

export function saveChain(chain: Chain): void {
  localStorage.setItem(STORAGE_KEY, chain);
}

interface ChainPickerProps {
  value: Chain;
  onChange: (chain: Chain) => void;
}

export const ChainPicker: React.FC<ChainPickerProps> = ({ value, onChange }) => (
  <select
    value={value}
    onChange={(e) => onChange(e.target.value as Chain)}
    style={{
      appearance: 'none',
      WebkitAppearance: 'none',
      background: `var(--surface) url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23888888' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E") no-repeat right 10px center`,
      color: 'var(--text-primary)',
      border: '1px solid var(--border)',
      borderRadius: 6,
      padding: '0 28px 0 12px',
      height: 32,
      fontSize: 13,
      cursor: 'pointer',
      outline: 'none',
    }}
    onFocus={(e) => { e.currentTarget.style.borderColor = 'var(--accent-border)'; }}
    onBlur={(e) => { e.currentTarget.style.borderColor = 'var(--border)'; }}
  >
    {CHAINS.map((c) => (
      <option key={c} value={c}>{c}</option>
    ))}
  </select>
);
